import React from 'react'

const EditMyAddress = () => {
  return (
    <div>
      <h2>EditMyAddress</h2>
    </div>
  )
}

export default EditMyAddress
